import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app.component";
import {providePrimeNG} from 'primeng/config';
import Lara from '@primeuix/themes/lara';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: 'none'
        }
      }
    }),
    importProvidersFrom(AppModule)
  ]
}).catch(err => console.error(err));
